export const rtc_webjs_grs_sdk_global_route_config = {
    grs_sdk_global_route_config_hwrtc: {
        applications: [],
        services: [
            {
                name: 'com.huawei.cloud.videortn',
                routeBy: 'ser_country>geo_ip',
                servings: [
                    {
                        countryOrAreaGroup: 'DR1',
                        addresses: {
                            GLOBAL: 'wss://rtc.platform.dbankcloud.com',
                            GREEN: 'wss://vediortn-green.huaweicloud.cn:8445',
                            BLUE: 'wss://rtcmirror.hwcloudtest.cn:8445',
                            ROOT: 'wss://rtc-drcn.platform.dbankcloud.com',
                        },
                    },
                    {
                        countryOrAreaGroup: 'DR2',
                        addresses: {
                            GLOBAL: 'wss://rtc.platform.dbankcloud.com',
                            GREEN: 'wss://vediortn-green.huaweicloud.cn:8445',
                            BLUE: 'wss://rtcmirror.hwcloudtest.cn:8445',
                            ROOT: 'wss://rtc-dra.platform.dbankcloud.com',
                        },
                    },
                    {
                        countryOrAreaGroup: 'DR3',
                        addresses: {
                            GLOBAL: 'wss://rtc.platform.dbankcloud.com',
                            GREEN: 'wss://vediortn-green.huaweicloud.cn:8445',
                            BLUE: 'wss://rtcmirror.hwcloudtest.cn:8445',
                            ROOT: 'wss://rtc-dre.platform.dbankcloud.com',
                        },
                    },
                    {
                        countryOrAreaGroup: 'DR4',
                        addresses: {
                            GLOBAL: 'wss://rtc.platform.dbankcloud.com',
                            GREEN: 'wss://vediortn-green.huaweicloud.cn:8445',
                            BLUE: 'wss://rtcmirror.hwcloudtest.cn:8445',
                            ROOT: 'wss://rtc-drru.platform.dbankcloud.com',
                        },
                    },
                ],
                countryOrAreaGroups: [],
            },
        ],
        countryOrAreaGroups: [
            {
                id: 'DR1',
                name: 'China',
                countriesOrAreas: ['CN'],
                description: 'China zone',
            },
            {
                id: 'DR2',
                name: 'Asian-African-Latin American',
                countriesOrAreas: [
                    'AE',
                    'AF',
                    'AG',
                    'AI',
                    'AM',
                    'AO',
                    'AQ',
                    'AR',
                    'AS',
                    'AW',
                    'AZ',
                    'BB',
                    'BD',
                    'BF',
                    'BH',
                    'BI',
                    'BJ',
                    'BL',
                    'BM',
                    'BN',
                    'BO',
                    'BR',
                    'BS',
                    'BT',
                    'BV',
                    'BW',
                    'BY',
                    'BZ',
                    'CC',
                    'CD',
                    'CF',
                    'CG',
                    'CI',
                    'CK',
                    'CL',
                    'CM',
                    'CO',
                    'CR',
                    'CU',
                    'CV',
                    'CX',
                    'DJ',
                    'DM',
                    'DO',
                    'DZ',
                    'EC',
                    'EG',
                    'EH',
                    'ER',
                    'ET',
                    'FJ',
                    'FK',
                    'FM',
                    'GA',
                    'GD',
                    'GE',
                    'GF',
                    'GH',
                    'GM',
                    'GN',
                    'GP',
                    'GQ',
                    'GS',
                    'GT',
                    'GU',
                    'GW',
                    'GY',
                    'HK',
                    'HM',
                    'HN',
                    'HT',
                    'ID',
                    'IN',
                    'IO',
                    'IQ',
                    'JM',
                    'JO',
                    'JP',
                    'KE',
                    'KG',
                    'KH',
                    'KI',
                    'KM',
                    'KN',
                    'KP',
                    'KR',
                    'KW',
                    'KY',
                    'KZ',
                    'LA',
                    'LB',
                    'LC',
                    'LK',
                    'LR',
                    'LS',
                    'LY',
                    'MA',
                    'MG',
                    'MH',
                    'ML',
                    'MM',
                    'MN',
                    'MO',
                    'MP',
                    'MQ',
                    'MR',
                    'MS',
                    'MU',
                    'MV',
                    'MW',
                    'MX',
                    'MY',
                    'MZ',
                    'NA',
                    'NC',
                    'NE',
                    'NF',
                    'NG',
                    'NI',
                    'NP',
                    'NR',
                    'NU',
                    'OM',
                    'PA',
                    'PE',
                    'PF',
                    'PG',
                    'PH',
                    'PK',
                    'PN',
                    'PR',
                    'PS',
                    'PW',
                    'PY',
                    'QA',
                    'RE',
                    'RW',
                    'SA',
                    'SB',
                    'SC',
                    'SD',
                    'SG',
                    'SH',
                    'SL',
                    'SN',
                    'SO',
                    'SR',
                    'SS',
                    'ST',
                    'SV',
                    'SY',
                    'SZ',
                    'TC',
                    'TD',
                    'TF',
                    'TG',
                    'TH',
                    'TJ',
                    'TK',
                    'TL',
                    'TM',
                    'TN',
                    'TO',
                    'TT',
                    'TV',
                    'TW',
                    'TZ',
                    'UG',
                    'UY',
                    'UZ',
                    'VE',
                    'VG',
                    'VI',
                    'VN',
                    'VU',
                    'WF',
                    'WS',
                    'YE',
                    'YT',
                    'ZA',
                    'ZM',
                    'ZW',
                ],
                description: 'Asian-African-Latin American zone',
            },
            {
                id: 'DR3',
                name: 'Europe',
                countriesOrAreas: [
                    'AD',
                    'AL',
                    'AN',
                    'AT',
                    'AU',
                    'AX',
                    'BA',
                    'BE',
                    'BG',
                    'BQ',
                    'CA',
                    'CH',
                    'CW',
                    'CY',
                    'CZ',
                    'DE',
                    'DK',
                    'EE',
                    'ES',
                    'FI',
                    'FO',
                    'FR',
                    'GB',
                    'GG',
                    'GI',
                    'GL',
                    'GR',
                    'HR',
                    'HU',
                    'IE',
                    'IL',
                    'IM',
                    'IS',
                    'IT',
                    'JE',
                    'LI',
                    'LT',
                    'LU',
                    'LV',
                    'MC',
                    'MD',
                    'ME',
                    'MF',
                    'MK',
                    'MT',
                    'NL',
                    'NO',
                    'NZ',
                    'PL',
                    'PM',
                    'PT',
                    'RO',
                    'RS',
                    'SE',
                    'SI',
                    'SJ',
                    'SK',
                    'SM',
                    'SX',
                    'TR',
                    'UA',
                    'UM',
                    'US',
                    'VA',
                    'VC',
                    'XK',
                    'YK',
                ],
                description: 'Europe zone',
            },
            {
                id: 'DR4',
                name: 'Russia',
                countriesOrAreas: ['RU'],
                description: 'Russia zone',
            },
            {
                id: 'DR5',
                name: 'A2',
                countriesOrAreas: ['IR'],
                description: 'A2 zone',
            },
        ],
    },
    grs_sdk_global_route_config_rtcha: {
        applications: [],
        services: [
            {
                name: 'com.huawei.cloud.hianalytics',
                routeBy: 'ser_country',
                servings: [
                    {
                        countryOrAreaGroup: 'DR1',
                        addresses: {
                            ROOT: 'https://metrics1.data.hicloud.com:6447',
                        },
                    },
                    {
                        countryOrAreaGroup: 'DR2',
                        addresses: {
                            ROOT: 'https://metrics3.data.hicloud.com:6447',
                        },
                    },
                    {
                        countryOrAreaGroup: 'DR3',
                        addresses: {
                            ROOT: 'https://metrics2.data.hicloud.com:6447',
                        },
                    },
                    {
                        countryOrAreaGroup: 'DR4',
                        addresses: {
                            ROOT: 'https://metrics5.data.hicloud.com:6447',
                        },
                    },
                    {
                        countryOrAreaGroup: 'DR5',
                        addresses: {
                            ROOT: 'https://metrics4.data.hicloud.com:6447',
                        },
                    },
                ],
                countryOrAreaGroups: [],
            },
            {
                name: 'com.huawei.cloud.hianalytics.aspg',
                routeBy: 'ser_country',
                servings: [
                    {
                        countryOrAreaGroup: 'DR1',
                        addresses: {
                            ROOT: 'https://metrics1.data.hicloud.com:6447',
                        },
                    },
                    {
                        countryOrAreaGroup: 'DR2',
                        addresses: {
                            ROOT: 'https://metrics-dra.dt.hicloud.com:6447',
                        },
                    },
                    {
                        countryOrAreaGroup: 'DR3',
                        addresses: {
                            ROOT: 'https://metrics2.data.hicloud.com:6447',
                        },
                    },
                    {
                        countryOrAreaGroup: 'DR4',
                        addresses: {
                            ROOT: 'https://metrics5.data.hicloud.com:6447',
                        },
                    },
                    {
                        countryOrAreaGroup: 'DR5',
                        addresses: {
                            ROOT: 'https://metrics4.data.hicloud.com:6447',
                        },
                    },
                ],
                countryOrAreaGroups: [],
            },
        ],
        countryOrAreaGroups: [
            {
                id: 'DR1',
                name: 'China',
                countriesOrAreas: ['CN'],
                description: 'China zone',
            },
            {
                id: 'DR2',
                name: 'Asian-African-Latin American',
                countriesOrAreas: [
                    'AE',
                    'AF',
                    'AG',
                    'AI',
                    'AM',
                    'AO',
                    'AQ',
                    'AR',
                    'AS',
                    'AW',
                    'AZ',
                    'BB',
                    'BD',
                    'BF',
                    'BH',
                    'BI',
                    'BJ',
                    'BL',
                    'BM',
                    'BN',
                    'BO',
                    'BR',
                    'BS',
                    'BT',
                    'BV',
                    'BW',
                    'BY',
                    'BZ',
                    'CC',
                    'CD',
                    'CF',
                    'CG',
                    'CI',
                    'CK',
                    'CL',
                    'CM',
                    'CO',
                    'CR',
                    'CU',
                    'CV',
                    'CX',
                    'DJ',
                    'DM',
                    'DO',
                    'DZ',
                    'EC',
                    'EG',
                    'EH',
                    'ER',
                    'ET',
                    'FJ',
                    'FK',
                    'FM',
                    'GA',
                    'GD',
                    'GE',
                    'GF',
                    'GH',
                    'GM',
                    'GN',
                    'GP',
                    'GQ',
                    'GS',
                    'GT',
                    'GU',
                    'GW',
                    'GY',
                    'HK',
                    'HM',
                    'HN',
                    'HT',
                    'ID',
                    'IN',
                    'IO',
                    'IQ',
                    'JM',
                    'JO',
                    'JP',
                    'KE',
                    'KG',
                    'KH',
                    'KI',
                    'KM',
                    'KN',
                    'KP',
                    'KR',
                    'KW',
                    'KY',
                    'KZ',
                    'LA',
                    'LB',
                    'LC',
                    'LK',
                    'LR',
                    'LS',
                    'LY',
                    'MA',
                    'MG',
                    'MH',
                    'ML',
                    'MM',
                    'MN',
                    'MO',
                    'MP',
                    'MQ',
                    'MR',
                    'MS',
                    'MU',
                    'MV',
                    'MW',
                    'MX',
                    'MY',
                    'MZ',
                    'NA',
                    'NC',
                    'NE',
                    'NF',
                    'NG',
                    'NI',
                    'NP',
                    'NR',
                    'NU',
                    'OM',
                    'PA',
                    'PE',
                    'PF',
                    'PG',
                    'PH',
                    'PK',
                    'PN',
                    'PR',
                    'PS',
                    'PW',
                    'PY',
                    'QA',
                    'RE',
                    'RW',
                    'SA',
                    'SB',
                    'SC',
                    'SD',
                    'SG',
                    'SH',
                    'SL',
                    'SN',
                    'SO',
                    'SR',
                    'SS',
                    'ST',
                    'SV',
                    'SY',
                    'SZ',
                    'TC',
                    'TD',
                    'TF',
                    'TG',
                    'TH',
                    'TJ',
                    'TK',
                    'TL',
                    'TM',
                    'TN',
                    'TO',
                    'TT',
                    'TV',
                    'TW',
                    'TZ',
                    'UG',
                    'UY',
                    'UZ',
                    'VE',
                    'VG',
                    'VI',
                    'VN',
                    'VU',
                    'WF',
                    'WS',
                    'YE',
                    'YT',
                    'ZA',
                    'ZM',
                    'ZW',
                ],
                description: 'Asian-African-Latin American zone',
            },
            {
                id: 'DR3',
                name: 'Europe',
                countriesOrAreas: [
                    'AD',
                    'AL',
                    'AN',
                    'AT',
                    'AU',
                    'AX',
                    'BA',
                    'BE',
                    'BG',
                    'BQ',
                    'CA',
                    'CH',
                    'CW',
                    'CY',
                    'CZ',
                    'DE',
                    'DK',
                    'EE',
                    'ES',
                    'FI',
                    'FO',
                    'FR',
                    'GB',
                    'GG',
                    'GI',
                    'GL',
                    'GR',
                    'HR',
                    'HU',
                    'IE',
                    'IL',
                    'IM',
                    'IS',
                    'IT',
                    'JE',
                    'LI',
                    'LT',
                    'LU',
                    'LV',
                    'MC',
                    'MD',
                    'ME',
                    'MF',
                    'MK',
                    'MT',
                    'NL',
                    'NO',
                    'NZ',
                    'PL',
                    'PM',
                    'PT',
                    'RO',
                    'RS',
                    'SE',
                    'SI',
                    'SJ',
                    'SK',
                    'SM',
                    'SX',
                    'TR',
                    'UA',
                    'UM',
                    'US',
                    'VA',
                    'VC',
                    'XK',
                    'YK',
                ],
                description: 'Europe zone',
            },
            {
                id: 'DR4',
                name: 'Russia',
                countriesOrAreas: ['RU'],
                description: 'Russia zone',
            },
            {
                id: 'DR5',
                name: 'A2',
                countriesOrAreas: ['IR'],
                description: 'A2 zone',
            },
        ],
    },
}